@if (value) {
  <i
    class="icon-circleCheckmark-outline font-bold"
    style="color: #4ead58"
  ></i>
} @else {
  <i class="icon-circleDelete-outline font-bold" style="color: #c52a1a"></i
    >
  }
